module.exports = __webpack_public_path__ + "img/zixun.75f5f31c.png";